// Db Samples — vanilla JS port of the prototype's interactive bits.
// Includes: cover-zoom lightbox, SampleBrowser (folder switch + audio), AJAX add-to-cart, cart count refresh.

(function () {
  'use strict';

  // ---------- Cover zoom lightbox ----------
  document.querySelectorAll('[data-zoom-target]').forEach(function (el) {
    el.style.cursor = 'zoom-in';
    el.addEventListener('click', function () {
      var src = el.getAttribute('data-zoom-target');
      var alt = el.getAttribute('data-zoom-alt') || '';
      var lb = document.createElement('div');
      lb.className = 'lightbox';
      lb.innerHTML =
        '<button class="lightbox-close" aria-label="Close">×</button>' +
        '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
      function close() {
        document.removeEventListener('keydown', onKey);
        lb.remove();
      }
      function onKey(e) { if (e.key === 'Escape') close(); }
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('lightbox-close')) close();
      });
      lb.querySelector('img').addEventListener('click', function (e) { e.stopPropagation(); });
      document.body.appendChild(lb);
      document.addEventListener('keydown', onKey);
    });
  });

  // ---------- SampleBrowser ----------
  document.querySelectorAll('[data-sample-browser]').forEach(function (root) {
    var folders = [];
    try { folders = JSON.parse(root.dataset.folders || '[]'); } catch (e) { folders = []; }
    if (!folders.length) { root.style.display = 'none'; return; }

    var sideEl = root.querySelector('[data-browser-side]');
    var mainEl = root.querySelector('[data-browser-main]');
    var audioEl = root.querySelector('[data-browser-audio]');
    var variantId = root.dataset.variantId;
    var assetBase = root.dataset.assetBase || '';

    function resolveSrc(src) {
      if (!src) return '';
      if (/^(https?:)?\/\//.test(src)) return src;
      return assetBase + src;
    }

    var activeIdx = 0;
    var playingSrc = null;

    audioEl.addEventListener('ended', function () {
      playingSrc = null;
      render();
    });

    function togglePlay(src) {
      if (playingSrc === src) {
        audioEl.pause();
        playingSrc = null;
      } else {
        audioEl.src = resolveSrc(src);
        audioEl.play().catch(function(){});
        playingSrc = src;
      }
      render();
    }

    function waveform(ti) {
      var bars = '';
      for (var bi = 0; bi < 20; bi++) {
        var h = 25 + ((bi * 17 + ti * 11) % 70);
        bars += '<span class="wf-b" style="height:' + h + '%"></span>';
      }
      return '<span class="wf">' + bars + '</span>';
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function render() {
      // Sidebar
      sideEl.innerHTML = '<div class="browser-side-h">Folders</div>' +
        folders.map(function (f, i) {
          var n = (f.count != null) ? f.count : (f.tracks ? f.tracks.length : 0);
          return '<div class="browser-side-item ' + (i === activeIdx ? 'on' : '') + '" data-idx="' + i + '">' +
            '<span class="ic">📁</span>' +
            '<span class="nm">' + escapeHtml(f.name) + '</span>' +
            '<span class="ct">' + n + '</span>' +
            '</div>';
        }).join('');

      sideEl.querySelectorAll('[data-idx]').forEach(function (el) {
        el.addEventListener('click', function () {
          activeIdx = parseInt(el.dataset.idx, 10);
          render();
        });
      });

      // Main
      var active = folders[activeIdx] || {};
      var tracks = active.tracks || [];

      if (tracks.length === 0) {
        mainEl.innerHTML =
          '<div class="browser-locked">' +
            '<div class="lk">🔒</div>' +
            '<div class="lh">' + (active.count || 0) + ' ' + escapeHtml(active.name || '') + ' locked</div>' +
            '<button class="btn primary browser-cta" data-unlock>Unlock</button>' +
          '</div>';
      } else {
        var playableCount = tracks.filter(function (t) { return !t.locked; }).length;
        var rows = tracks.map(function (t, ti) {
          if (t.locked) {
            return '<li class="browser-row locked-track" aria-hidden="true">' +
              '<span class="play lock">🔒</span>' +
              (t.bpm ? '<span class="bpm">' + t.bpm + ' BPM</span>' : '') +
              '<span class="nm">' + escapeHtml(t.name) + '<span class="ext">.wav</span></span>' +
              waveform(ti) +
            '</li>';
          }
          var isPlaying = playingSrc === t.src;
          return '<li class="browser-row ' + (isPlaying ? 'playing' : '') + '" data-src="' + escapeHtml(t.src) + '">' +
            '<span class="play">' + (isPlaying ? '■' : '▶') + '</span>' +
            (t.bpm ? '<span class="bpm">' + t.bpm + ' BPM</span>' : '') +
            '<span class="nm">' + escapeHtml(t.name) + '<span class="ext">.wav</span></span>' +
            waveform(ti) +
          '</li>';
        }).join('');

        var moreCount = (active.count != null) ? active.count - playableCount : 0;
        var unlockBlock = moreCount > 0 ? (
          '<div class="browser-unlock" data-unlock>' +
            '<div class="lk">🔒</div>' +
            '<div class="ut">+' + moreCount + ' more in ' + escapeHtml(active.name || '') + '</div>' +
            '<button class="btn primary browser-cta" data-unlock>Unlock</button>' +
          '</div>'
        ) : '';

        mainEl.innerHTML = '<ul class="browser-list">' + rows + '</ul>' + unlockBlock;

        mainEl.querySelectorAll('.browser-row:not(.locked-track)').forEach(function (el) {
          el.addEventListener('click', function () { togglePlay(el.dataset.src); });
        });
      }

      mainEl.querySelectorAll('[data-unlock]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.stopPropagation();
          addToCart(variantId);
        });
      });
    }

    render();
  });

  // ---------- AJAX add-to-cart ----------
  // Sample packs are digital — qty > 1 makes no sense. Always force qty = 1.
  function addToCart(variantId) {
    var vid = String(variantId);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = cart.items.find(function (i) { return String(i.variant_id) === vid; });
        if (existing) {
          // Already in cart — just open the drawer, don't increment.
          return refreshCartCount().then(openDrawer);
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshCartCount(); })
          .then(function () { openDrawer(); });
      })
      .catch(function (e) { console.error('Add to cart failed', e); });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = String(cart.item_count).padStart(2, '0');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
        document.querySelectorAll('[data-drawer-count]').forEach(function (el) { el.textContent = count; });
        renderDrawer(cart);
        return cart;
      });
  }

  // ---------- Cart drawer ----------
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerBody = document.querySelector('[data-drawer-body]');
  var drawerFooter = document.querySelector('[data-drawer-f]');
  var drawerSubtotal = document.querySelector('[data-drawer-subtotal]');
  var drawerTotal = document.querySelector('[data-drawer-total]');
  var drawerDiscRow = document.querySelector('[data-drawer-discount-row]');
  var drawerDisc = document.querySelector('[data-drawer-discount]');
  var drawerDiscLabel = document.querySelector('[data-drawer-discount-label]');
  var drawerBackdrop = document.querySelector('[data-cart-backdrop]');
  var drawerTier = document.querySelector('[data-drawer-tier]');
  var drawerTierMsg = document.querySelector('[data-drawer-tier-msg]');
  var drawerTierFill = document.querySelector('[data-drawer-tier-fill]');
  var drawerRecs = document.querySelector('[data-drawer-recs]');
  var drawerRecsTrack = document.querySelector('[data-drawer-recs-track]');

  // Discount tiers — must mirror Shopify Automatic Discounts in Admin.
  // Toggle visibility via Theme Customizer → Cart → "Show quantity-tier discount bar".
  var TIERS_ENABLED = !(window.dbsamples && window.dbsamples.tiersEnabled === false);
  var TIERS = [
    { qty: 3, pct: 0.10, label: '10% off' },
    { qty: 4, pct: 0.15, label: '15% off' },
    { qty: 5, pct: 0.25, label: '25% off' }
  ];

  var prevTierIdx = null; // last rendered tier index; null until first non-empty render

  function currentTier(itemCount) {
    var match = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (itemCount >= TIERS[i].qty) match = TIERS[i];
    }
    return match;
  }
  function nextTier(itemCount) {
    for (var i = 0; i < TIERS.length; i++) {
      if (itemCount < TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('on');
    if (drawerBackdrop) drawerBackdrop.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('on');
    if (drawerBackdrop) drawerBackdrop.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var cleaningBundle = false;
  function renderDrawer(cart) {
    // The bundle already contains every pack: drop single packs that sit next to it (plugins stay).
    if (cart && cart.items && !cleaningBundle && cart.items.some(function (it) { return it.product_type === 'Bundle'; })) {
      var dupes = cart.items.filter(function (it) { return it.product_type !== 'Bundle' && it.product_type !== 'Plugin'; });
      if (dupes.length) {
        cleaningBundle = true;
        var upd = {};
        dupes.forEach(function (it) { upd[it.key] = 0; });
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: upd }) })
          .then(function () { cleaningBundle = false; return refreshCartCount(); })
          .catch(function () { cleaningBundle = false; });
        return;
      }
    }
    if (!drawerBody) return;
    if (!cart || cart.items.length === 0) {
      drawerBody.innerHTML = '<div class="drawer-empty">Cart is empty.</div>';
      if (drawerFooter) drawerFooter.style.display = 'none';
      if (drawerTier) drawerTier.hidden = true;
      if (drawerRecs) drawerRecs.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="" style="width:100%;height:100%;object-fit:cover">' : '';
      return '<div class="drawer-row" data-line-key="' + item.key + '">' +
        '<div class="cover" style="width:60px;height:60px;padding:0;overflow:hidden">' + img + '</div>' +
        '<div>' +
          '<div class="n">' + item.product_title + '</div>' +
          '<div class="m">' + (item.product_type || '') + '</div>' +
        '</div>' +
        '<div>' +
          '<div class="p">' + (item.original_line_price > item.final_line_price ? '<s class="was">' + money(item.original_line_price) + '</s> '
            : (item.product_type === 'Bundle' && drawer && drawer.dataset.bundleWas ? '<s class="was">' + drawer.dataset.bundleWas + '</s> ' : '')) + money(item.final_line_price) + '</div>' +
          '<div class="x" data-line-remove="' + item.key + '">×</div>' +
        '</div>' +
      '</div>';
    }).join('');
    drawerBody.querySelectorAll('[data-line-remove]').forEach(function (el) {
      el.addEventListener('click', function () { removeLine(el.dataset.lineRemove); });
    });

    // All Packs bundle line: with 1 or 2 packs in the cart, offer all 9 for the bundle price.
    var bundleVariant = drawer && drawer.dataset.bundleVariant;
    var packLines = cart.items.filter(function (it) { return it.product_type !== 'Plugin' && it.product_type !== 'Bundle'; });
    var hasBundle = cart.items.some(function (it) { return it.product_type === 'Bundle' || String(it.variant_id) === String(bundleVariant); });
    if (bundleVariant && !hasBundle && packLines.length >= 1 && packLines.length <= 2) {
      var covers = [];
      try { covers = JSON.parse(drawer.dataset.bundleCovers || '[]'); } catch (e) { covers = []; }
      var paying = packLines.reduce(function (s, it) { return s + it.final_line_price; }, 0);
      var row = document.createElement('div');
      row.className = 'drawer-row drawer-bundle-row';
      row.innerHTML =
        '<div class="stack">' + covers.slice(0, 3).reverse().map(function (c) { return '<img src="' + c + '" alt="">'; }).join('') + '</div>' +
        '<div><div class="pay">you\'re paying ' + money(paying) + ' for ' + packLines.length + (packLines.length === 1 ? ' pack.' : ' packs.') + '</div>' +
        '<div class="get">get all 9 for ' + (drawer.dataset.bundlePrice || '$149') + '.</div></div>' +
        '<div><button type="button" class="rec-add" data-bundle-swap>swap for all 9</button></div>';
      drawerBody.appendChild(row);
      row.querySelector('[data-bundle-swap]').addEventListener('click', function () {
        var updates = {};
        packLines.forEach(function (it) { updates[it.key] = 0; });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return addToCart(bundleVariant); });
      });
    }

    var count = cart.items.filter(function (it) { return it.product_type !== 'Plugin' && it.product_type !== 'Bundle'; }).length;
    var tier = TIERS_ENABLED ? currentTier(count) : null;
    var nxt = TIERS_ENABLED ? nextTier(count) : null;
    // Shopify applies the automatic tier discount inside the cart JSON itself
    // (line prices, items_subtotal_price and total_price are already discounted).
    // Display Shopify's numbers; NEVER re-derive the discount on top of them.
    var subtotal = cart.original_total_price;
    var discount = cart.total_discount || 0;
    var total = cart.total_price;
    // Expected saving for the tier message if Shopify hasn't applied it in-cart
    var estSaving = (tier && !discount) ? Math.round(subtotal * tier.pct) : discount;

    // Tier banner
    if (drawerTier) {
      // the bundle already has every pack: the "add more packs" bar makes no sense next to it
      var bundleInCart = cart.items.some(function (it) { return it.product_type === 'Bundle'; });
      if (!TIERS_ENABLED || bundleInCart) {
        drawerTier.hidden = true;
      } else {
        drawerTier.hidden = false;
        // Piecewise fill: each bar segment spans one tier, so the fill only
        // reaches a tier's marker when its quantity is actually met.
        var seg = 100 / TIERS.length;
        var pctFill = 100;
        for (var ti = 0; ti < TIERS.length; ti++) {
          if (count < TIERS[ti].qty) {
            var prevQty = ti === 0 ? 0 : TIERS[ti - 1].qty;
            pctFill = (ti + (count - prevQty) / (TIERS[ti].qty - prevQty)) * seg;
            break;
          }
        }
        if (drawerTierFill) drawerTierFill.style.width = pctFill + '%';
        if (drawerTierMsg) {
          if (nxt && tier) {
            var need = nxt.qty - count;
            drawerTierMsg.innerHTML = '<b>' + tier.label + ' unlocked</b> \u00b7 saving <b>' + money(estSaving) + '</b> \u00b7 add ' + need + ' more for <b>' + nxt.label + '</b>';
          } else if (nxt) {
            var need2 = nxt.qty - count;
            drawerTierMsg.innerHTML = 'Add <b>' + need2 + '</b> ' + (need2 === 1 ? 'pack' : 'packs') + ' to unlock <b>' + nxt.label + '</b>';
          } else {
            drawerTierMsg.innerHTML = '<b>Max unlocked \u00b7 ' + tier.label + '</b> \u00b7 saving <b>' + money(estSaving) + '</b>';
          }
        }
        // Checkpoint nodes: reflect owned tiers; pop + shine only on upward cross.
        var tierIdx = tier ? TIERS.indexOf(tier) : -1;
        var nodes = document.querySelectorAll('[data-tier-node]');
        nodes.forEach(function (node) {
          var i = parseInt(node.dataset.tierNode, 10);
          node.classList.toggle('unlocked', count >= TIERS[i].qty);
          if (prevTierIdx !== null && tierIdx > prevTierIdx && i > prevTierIdx && i <= tierIdx) {
            node.classList.add('just-unlocked');
            setTimeout(function () { node.classList.remove('just-unlocked'); }, 800);
          }
        });
        if (prevTierIdx !== null && tierIdx > prevTierIdx) {
          var barEl = document.querySelector('[data-drawer-tier-bar]');
          if (barEl) {
            barEl.classList.add('flash');
            setTimeout(function () { barEl.classList.remove('flash'); }, 900);
          }
        }
        prevTierIdx = tierIdx;
      }
    }

    if (drawerSubtotal) drawerSubtotal.textContent = money(subtotal);
    if (drawerTotal) drawerTotal.textContent = money(total);
    if (drawerDiscRow) drawerDiscRow.style.display = discount === 0 ? 'none' : '';
    if (drawerDiscLabel && tier) drawerDiscLabel.textContent = count + ' packs ' + tier.label;
    if (drawerDisc) drawerDisc.textContent = '−' + money(discount);
    if (drawerFooter) drawerFooter.style.display = '';

    loadRecommendations(cart);
  }

  function loadRecommendations(cart) {
    if (!drawerRecs || !drawerRecsTrack) return;
    if (!cart.items.length) { drawerRecs.hidden = true; return; }
    var firstId = cart.items[0].product_id;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var toasterP = fetch('/products/drum-toaster.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    Promise.all([
      fetch('/recommendations/products.json?product_id=' + firstId + '&intent=related&limit=6').then(function (r) { return r.json(); }),
      toasterP
    ])
      .then(function (res) {
        var d = res[0], toaster = res[1];
        // Drum Toaster always leads the recs (full price, an add-on, never a bundle discount)
        if (toaster && toaster.available && !inCart[toaster.id]) {
          d.products = [toaster].concat((d.products || []).filter(function (p) { return p.id !== toaster.id; }));
        }
        var prods = (d.products || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 4);
        if (prods.length === 0) { drawerRecs.hidden = true; return; }
        drawerRecs.hidden = false;
        drawerRecsTrack.innerHTML = prods.map(function (p) {
          var v = (p.variants && p.variants[0]) || {};
          var img = (p.featured_image || (p.images && p.images[0]) || '') + '';
          return '<div class="rec-card">' +
            '<a href="' + p.url + '" class="rec-cover">' +
              (img ? '<img src="' + img + '" alt="">' : '') +
            '</a>' +
            '<div class="rec-info">' +
              '<a href="' + p.url + '" class="rec-title">' + p.title + '</a>' +
              '<div class="rec-price">' + money(v.price || 0) + '</div>' +
            '</div>' +
            '<button type="button" class="rec-add" data-rec-add="' + v.id + '">Add +</button>' +
          '</div>';
        }).join('');
        drawerRecsTrack.querySelectorAll('[data-rec-add]').forEach(function (el) {
          el.addEventListener('click', function () { addToCart(el.dataset.recAdd); });
        });
      })
      .catch(function () { drawerRecs.hidden = true; });
  }
  // Carousel arrows
  var recsPrev = document.querySelector('[data-recs-prev]');
  var recsNext = document.querySelector('[data-recs-next]');
  if (recsPrev) recsPrev.addEventListener('click', function () { if (drawerRecsTrack) drawerRecsTrack.scrollBy({ left: -240, behavior: 'smooth' }); });
  if (recsNext) recsNext.addEventListener('click', function () { if (drawerRecsTrack) drawerRecsTrack.scrollBy({ left: 240, behavior: 'smooth' }); });

  function removeLine(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      var count = String(cart.item_count).padStart(2, '0');
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
      document.querySelectorAll('[data-drawer-count]').forEach(function (el) { el.textContent = count; });
      renderDrawer(cart);
    });
  }

  // YouTube deferred load — click poster, swap in iframe (Spotlight pattern)
  document.querySelectorAll('[data-yt-poster]').forEach(function (poster) {
    poster.addEventListener('click', function () {
      var id = poster.getAttribute('data-yt-id');
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = 'Preview';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      poster.replaceWith(iframe);
    });
  });

  // Mobile nav drawer toggle
  document.querySelectorAll('[data-nav-toggle]').forEach(function (el) {
    el.addEventListener('click', function () {
      var drawer = document.querySelector('[data-nav-drawer]');
      if (drawer) drawer.classList.toggle('open');
      el.classList.toggle('active');
    });
  });

  // Cart link opens drawer instead of going to /cart
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCartCount().then(openDrawer);
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('on')) closeDrawer();
  });

  // Initial cart fetch on page load to sync count
  refreshCartCount();

  // PDP add-to-cart form: intercept and use AJAX.
  document.querySelectorAll('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      var btn = form.querySelector('[data-add-btn]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      addToCart(idInput.value).finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to Cart'; }
      });
    });
  });

  // Quick-add hover button on pack cards.
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(btn.dataset.quickAdd);
    });
  });

  // ---------- Banner carousel ----------
  document.querySelectorAll('[data-banner-carousel]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-banner-slide]');
    var dots = document.querySelectorAll('[data-banner-dot]');
    var pauseBtn = document.querySelector('[data-banner-pause]');
    var prev = root.querySelector('[data-banner-prev]');
    var next = root.querySelector('[data-banner-next]');
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    if (slides.length <= 1) return;

    var idx = 0, paused = false, timer = null;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('on', j === idx); });
      dots.forEach(function (d, j) { d.classList.toggle('on', j === idx); });
    }
    function start() {
      stop();
      if (!paused) timer = setInterval(function () { show(idx + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); show(idx - 1); start(); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); show(idx + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.idx, 10)); start(); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.textContent = paused ? '▶' : '❚❚';
      start();
    });

    start();
  });

  // ---------- Catalog filters + sort ----------
  (function () {
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var filters = document.querySelectorAll('[data-filter]');
    var sortEl = document.querySelector('[data-sort]');

    function applyFilter(genre) {
      grid.querySelectorAll('.pack').forEach(function (card) {
        var cardGenre = card.dataset.genre || '';
        var match = (genre === 'All') || (cardGenre.toLowerCase() === genre.toLowerCase());
        card.style.display = match ? '' : 'none';
      });
    }

    function applySort(mode) {
      var cards = Array.from(grid.querySelectorAll('.pack'));
      cards.sort(function (a, b) {
        if (mode === 'price') return parseFloat(a.dataset.price || '0') - parseFloat(b.dataset.price || '0');
        if (mode === 'alpha') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        // 'new' = by year desc
        return parseInt(b.dataset.year || '0', 10) - parseInt(a.dataset.year || '0', 10);
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }

    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        filters.forEach(function (x) { x.classList.remove('active'); });
        f.classList.add('active');
        applyFilter(f.dataset.filter);
      });
    });
    if (sortEl) sortEl.addEventListener('change', function () { applySort(sortEl.value); });
    applySort('new');
  })();

  // ---------- Folder trigger → PackBrowser ----------
  document.querySelectorAll('[data-home-browser]').forEach(function (host) {
    var trigger = host.querySelector('[data-folder-trigger]');
    var browser = host.querySelector('[data-pack-browser]');
    if (!trigger || !browser) return;
    var initialized = false;

    trigger.addEventListener('click', function () {
      host.classList.add('is-open');
      if (!initialized) {
        initPackBrowser(browser, function () {
          host.classList.remove('is-open');
        });
        initialized = true;
      }
    });
  });

  function initPackBrowser(root, onCollapse) {
    if (!root) return;
    var packs = [];
    try { packs = JSON.parse(root.dataset.packs || '[]'); } catch (e) { packs = []; }
    var assetBase = root.dataset.assetBase || '';

    var sideEl = root.querySelector('[data-pb-side]');
    var mainEl = root.querySelector('[data-pb-main]');
    var audioEl = root.querySelector('[data-pb-audio]');

    var activeIdx = 0;
    var playingSrc = null;

    audioEl.addEventListener('ended', function () { playingSrc = null; render(); });

    function resolveSrc(src) {
      if (!src) return '';
      if (/^(https?:)?\/\//.test(src)) return src;
      return assetBase + src;
    }
    function togglePlay(src) {
      if (playingSrc === src) { audioEl.pause(); playingSrc = null; }
      else { audioEl.src = resolveSrc(src); audioEl.play().catch(function(){}); playingSrc = src; }
      render();
    }
    function waveform(ti) {
      var bars = '';
      for (var bi = 0; bi < 20; bi++) {
        var h = 25 + ((bi * 17 + ti * 11) % 70);
        bars += '<span class="wf-b" style="height:' + h + '%"></span>';
      }
      return '<span class="wf">' + bars + '</span>';
    }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function render() {
      // Sidebar — packs as folders w/ thumbnail
      sideEl.innerHTML = '<div class="browser-side-h">Packs</div>' +
        packs.map(function (p, i) {
          return '<div class="browser-side-item with-art ' + (i === activeIdx ? 'on' : '') + '" data-idx="' + i + '">' +
            '<span class="ic-art"><img src="' + escapeHtml(p.image || '') + '" alt=""></span>' +
            '<span class="nm">' + escapeHtml(p.title) + '</span>' +
            '</div>';
        }).join('');
      sideEl.querySelectorAll('[data-idx]').forEach(function (el) {
        el.addEventListener('click', function () { activeIdx = parseInt(el.dataset.idx, 10); render(); });
      });

      var active = packs[activeIdx] || {};
      var folders = active.folders || [];
      // Pick a folder to feature. If pack title hints at Fills, prefer Fills.
      // Otherwise default to Breaks → Fills → first non-empty.
      var titleLower = (active.title || '').toLowerCase();
      var preferFills = titleLower.indexOf('fill') !== -1;
      var breaks = null;
      if (folders.find) {
        var byName = function (n) { return folders.find(function (f) { return f.name && f.name.toLowerCase() === n; }); };
        if (preferFills) {
          breaks = byName('fills') || byName('breaks');
        } else {
          breaks = byName('breaks') || byName('fills');
        }
        if (!breaks) breaks = folders.find(function (f) { return f.tracks && f.tracks.length; });
      }
      var tracks = (breaks && breaks.tracks) || [];
      // Sum all folder counts to show pack-wide "+N more"
      var totalPackFiles = 0;
      for (var fi = 0; fi < folders.length; fi++) {
        if (folders[fi] && folders[fi].count) totalPackFiles += folders[fi].count;
      }

      if (tracks.length === 0) {
        mainEl.innerHTML =
          '<div class="browser-locked">' +
            '<div class="lk">🔒</div>' +
            '<div class="lh">' + escapeHtml(active.title || '') + '</div>' +
            '<a href="' + escapeHtml(active.url || '#') + '" class="btn primary browser-cta">View pack →</a>' +
          '</div>';
      } else {
        var playableCount = tracks.filter(function (t) { return !t.locked; }).length;
        var rows = tracks.map(function (t, ti) {
          if (t.locked) {
            return '<li class="browser-row locked-track" aria-hidden="true">' +
              '<span class="play lock">🔒</span>' +
              (t.bpm ? '<span class="bpm">' + t.bpm + ' BPM</span>' : '') +
              '<span class="nm">' + escapeHtml(t.name) + '<span class="ext">.wav</span></span>' +
              waveform(ti) +
            '</li>';
          }
          var isPlaying = playingSrc === t.src;
          return '<li class="browser-row ' + (isPlaying ? 'playing' : '') + '" data-src="' + escapeHtml(t.src) + '">' +
            '<span class="play">' + (isPlaying ? '■' : '▶') + '</span>' +
            (t.bpm ? '<span class="bpm">' + t.bpm + ' BPM</span>' : '') +
            '<span class="nm">' + escapeHtml(t.name) + '<span class="ext">.wav</span></span>' +
            waveform(ti) +
          '</li>';
        }).join('');

        var lockedCount = tracks.filter(function (t) { return t.locked; }).length;
        var moreCount = totalPackFiles - playableCount;
        if (moreCount <= 0) moreCount = (active.kit || 0) - playableCount;
        var unlockBlock = (lockedCount > 0 || moreCount > 0) ? (
          '<div class="browser-unlock" data-pb-unlock>' +
            '<div class="lk">🔒</div>' +
            '<div class="ut">' + (moreCount > 0 ? '+' + moreCount + ' more in ' : 'Unlock ') + escapeHtml(active.title || '') + '</div>' +
            '<button class="btn primary browser-cta" data-pb-unlock>Unlock</button>' +
          '</div>'
        ) : '';

        mainEl.innerHTML = '<ul class="browser-list">' + rows + '</ul>' + unlockBlock;
        mainEl.querySelectorAll('.browser-row:not(.locked-track)').forEach(function (el) {
          el.addEventListener('click', function () { togglePlay(el.dataset.src); });
        });
        mainEl.querySelectorAll('[data-pb-unlock]').forEach(function (el) {
          el.addEventListener('click', function (e) {
            e.stopPropagation();
            if (active.variantId) addToCart(active.variantId);
          });
        });
      }
    }

    function handleCollapse() {
      try { audioEl.pause(); audioEl.src = ''; } catch (e) {}
      if (onCollapse) onCollapse();
    }
    var closeDot = root.querySelector('[data-pb-close]');
    var minDot = root.querySelector('[data-pb-minimize]');
    if (closeDot) closeDot.addEventListener('click', handleCollapse);
    if (minDot) minDot.addEventListener('click', handleCollapse);

    render();
  }
})();

/* Mobile swipe for banner carousel — reuses existing prev/next handlers */
(function () {
  document.querySelectorAll('[data-banner-carousel]').forEach(function (root) {
    var prev = root.querySelector('[data-banner-prev]'),
        next = root.querySelector('[data-banner-next]');
    if (!prev || !next) return;
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        e.preventDefault();
        (dx < 0 ? next : prev).click();
      }
    }, { passive: false });
  });
})();
